import ClientThemeForm from './ClientThemeForm'

const Create = () => {
    return (
        <ClientThemeForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Theme created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create theme',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating theme...',
                },
            }}
        />
    )
}

export default Create
